import axios from "axios";

import config from "../config";
import { Toast } from "./toast";
import moment from "moment";
import { store } from "redux/store";
import { logout } from "redux/reducers/authSlice";

export const axiosInstance = axios.create({
  headers: {},
});

export const cancelTokenSource = axios.CancelToken.source();

export const setLocalStorageData = (key, value) => {
  localStorage.setItem(key, value);
};

export const getLocalStorageData = (key) => {
  if (!key) return null;
  return JSON.parse(localStorage.getItem(key));
};

export const getServiceUrl = (baseURL) => {
  let finalURL = "";

  switch (baseURL) {
    case "user":
      finalURL = config.api.userService;
      break;
    case "normal":
      finalURL = config.api.normalService;
      break;
    case "payment":
      finalURL = config.api.paymentService;
      break;
    case "cms":
      finalURL = config.api.cmsService;
      break;
    case "booking":
      finalURL = config.api.bookingService;
      break;
    case "cron":
      // cron api
      finalURL = "https://preprod-techapp-attendance.sobha.com/api/v1";

      break;
    default:
      finalURL = config.api.normalService;
  }

  return finalURL;
};

export const statusHelper = (status, data) => {
  if (data.status === 401 && cancelTokenSource) cancelTokenSource.cancel();

  if (data.status === 401 || data.status === 403) {
    Toast({ type: "error", message: data.statusText });
    store.dispatch(logout());
    window.location.href = "/";
  }
  if (status) {
    return { status: data.status, ...data.data };
  }
  return data.data;
};

export const isAuthorized = async () => {
  try {
    const token = localStorage.getItem("token")?.trim();

    return Boolean(token && token !== "undefined" && token !== "null");
  } catch (error) {
    return false;
  }
};

export const sortBy = (type, field, reverse, primer) => {
  debugger;
  const key = primer ? (item) => primer(item[field]) : (item) => item[field];

  const sortOrder =
    type === "descending"
      ? getDescendingSortOrder(reverse)
      : getAscendingSortOrder(reverse);

  return (a, b) => {
    const valueA = key(a);
    const valueB = key(b);

    return sortOrder * ((valueA > valueB) - (valueB > valueA));
  };
};

const getDescendingSortOrder = (reverse) => (reverse ? 1 : -1);

const getAscendingSortOrder = (reverse) => (reverse ? -1 : 1);

export const parseStringtoJSON = (data) => {
  try {
    const parsedData = JSON.parse(data);
    return parsedData || [];
  } catch (error) {
    console.error("Error parsing waistSize data:", error);
    return [];
  }
};

export const momentConvertor = (data, format) => {
  let modifiedData = data.map((d) => ({
    ...d,
    date: moment(d.date).format(format),
  }));
  return modifiedData;
};
